<template>
	<quote-modal 
      :tray-image-url="trayImageUrl" 
      :tray-name="selectedTrayName" 
      :tray-size="selectedTraySize" 
      :product-code="productCode" 
      v-if="showQuoteModal" 
      @close="showQuoteModal = false">
    </quote-modal>
	<email-modal :tray-image-url="trayImageUrl" v-if="showEmailModal" @close="showEmailModal = false"></email-modal>
	<div class="personal compartment">
		<div class="header">
			<a href="https://cambro.com/traydesigner/compartment-trays" class="left-arrow" target="_parent">
				<img src="images/left.svg" />
			</a>
			<h1>Compartment Trays</h1>
		</div>
		<div class="personal-left" ref="trayContainer">
      <div class="image-navigation">
        Logo Placement: 
        <button :class="{ active: currentImage === 1 }" @click="setCurrentImage(1)">1</button>
        <button :class="{ active: currentImage === 2 }" @click="setCurrentImage(2)">2</button>
        <button :class="{ active: currentImage === 3 }" @click="setCurrentImage(3)">3</button>
        <button :class="{ active: currentImage === 4 }" @click="setCurrentImage(4)">4</button>
      </div>
      <div id="tray-container">
          <transition name="fade" mode="out-in">
              <img :src="selectedTrayImage" :key="selectedTrayImage" width="100%" />
          </transition>
          <div v-if="uploadedImage && currentImage === 1" class="uploaded-image-1">
              <img :src="uploadedImage" alt="Uploaded Image" />
          </div>
          <div v-if="uploadedImage && currentImage === 2" class="uploaded-image-2">
              <img :src="uploadedImage" alt="Uploaded Image" />
          </div>
          <div v-if="uploadedImage && currentImage === 3" class="uploaded-image-3">
              <img :src="uploadedImage" alt="Uploaded Image" />
          </div>
          <div v-if="uploadedImage && currentImage === 4" class="uploaded-image-4">
              <img :src="uploadedImage" alt="Uploaded Image" />
          </div>
      </div>

		</div>
		<div class="personal-right">
			<h4>Select A Color</h4>
			<div class="select-color">
        <h5>Camwear</h5>
				<a href="javascript:void(0)" class="CWBeige133 active" @click="setActive($event, 'CWBeige133')"></a>
				<a href="javascript:void(0)" class="CWBlack110" @click="setActive($event, 'CWBlack110')"></a>
				<a href="javascript:void(0)" class="CWBlue168" @click="setActive($event, 'CWBlue168')"></a>
				<a href="javascript:void(0)" class="CWCranberry416" @click="setActive($event, 'CWCranberry416')"></a>
        <a href="javascript:void(0)" class="CWNavyBlue186" @click="setActive($event, 'CWNavyBlue186')"></a>
        <a href="javascript:void(0)" class="CWRed404" @click="setActive($event, 'CWRed404')"></a>
        <a href="javascript:void(0)" class="CWSherwoodGreen119" @click="setActive($event, 'CWSherwoodGreen119')"></a>
        <a href="javascript:void(0)" class="CWTeal414" @click="setActive($event, 'CWTeal414')"></a>
        <h5>Co-Polymer</h5>
        <a href="javascript:void(0)" class="CPCranberry416" @click="setActive($event, 'CPCranberry416')"></a>
			</div>

			<h4>Add a Logo</h4>
			<input type="file" @change="onFileChange" ref="fileInput" />
  			<button @click="resetUpload" class="btn-reset">Remove Image</button>
        <div class="cleaner"></div>

      <h4>Select Logo Color</h4>
      <div class="colorpickerbox"><color-picker v-model="logoColor"></color-picker></div>
      <div class="product-details">
        <h4>Your Tray Details:</h4>
        <h5>Tray Color: <strong>{{ selectedTrayName }}</strong></h5>
        <h5>Tray Size: <strong>{{ selectedTraySize }}</strong></h5>
        <h5>Product Code: <strong>{{ selectedTrayCode }}</strong></h5>
      </div>
      <button @click="captureScreenshot(false)" class="btn-quote">Request a Free Sample and Quote</button>
			<button @click="downloadImage" class="btn-download">Download</button>
			<button @click="captureScreenshot(true)" class="btn-email">Email My Tray</button>
		</div>
	</div>
</template>
  
<script>
  import { Compact } from '@ckpack/vue-color';
  import * as htmlToImage from 'html-to-image';
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
  import QuoteModal from './Quote.vue';
  import EmailModal from './EmailForm.vue';
  import '../assets/compartment.css';

  function hexToRgb(hex) {
    if (typeof hex !== 'string') {
      console.error('Expected a string but received:', hex);
      return null;
    }
    let r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  }
  export default {
	components: {
    'color-picker': Compact,
		QuoteModal,
    EmailModal
	},

	data() {
	  return {
      showQuoteModal: false,
      showEmailModal: false,
        emailFormData: {
        recipientEmail: '',
        message: '',
      },
      selectedTrayImage: 'images/compartment/compartment/1596CW-Beige-133.png',
      selectedColor: 'CWBeige133',
      selectedTrayName: 'Beige',
      selectedTrayCode: '1596CW133',
      selectedTraySize: '15" x 9" (38 x 22,9 cm)',
      selectedSizeCode: '1596',
      logoColor: '#ffffff',
      originalImage: null,
      uploadedImage: null,
      screenshot: null,
      currentImage: 1,
      colorToImageMap: {
        CWBeige133: 'images/compartment/compartment/1596CW-Beige-133.png',
        CWBlack110: 'images/compartment/compartment/1596CW-Black-110.png',
        CWBlue168: 'images/compartment/compartment/1596CW-Blue-168.png',
        CWCranberry416: 'images/compartment/compartment/1596CW-Cranberry-416.png',
        CWNavyBlue186: 'images/compartment/compartment/1596CW-Navy-Blue-186.png',
        CWRed404: 'images/compartment/compartment/1596CW-Red-404.png',
        CWSherwoodGreen119: 'images/compartment/compartment/1596CW-Sherwood-Green-119.png',
        CWTeal414: 'images/compartment/compartment/1596CW-Teal-414.png',
        CPCranberry416: 'images/compartment/compartment/1596CP-Cranberry-416.png',
      },
	  };
	},
	methods: {
		print(val) {
			console.log(val)
		},
		captureScreenshot() {
			const node = this.$refs.trayContainer;
      htmlToImage.toPng(node, {
        filter: function (node) {
            return node.nodeType === Node.ELEMENT_NODE && node.classList && !node.classList.contains('image-navigation');
          }
      })
				.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				this.showModal = true; // Show the modal after capturing the screenshot
				})
				.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
			this.showEmailModal = true;
		},
		captureScreenshot(openEmailModal = false) {
		const node = this.$refs.trayContainer;
    htmlToImage.toPng(node, {
        filter: function (node) {
            return node.nodeType === Node.ELEMENT_NODE && node.classList && !node.classList.contains('image-navigation');
          }
      })
			.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				if (openEmailModal) {
					this.showEmailModal = true; // Open email modal
					this.showQuoteModal = false; // Ensure quote modal is closed
				} else {
					this.showQuoteModal = true; // Open quote modal
					this.showEmailModal = false; // Ensure email modal is closed
				}
			})
			.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
		},
    convertHexToCSSFilter(hex) {
      return `drop-shadow(0 0 2px ${hex})`; // Example filter
    },
    resetUpload() {
      this.uploadedImage = null;
      this.$refs.fileInput.value = '';
	  },
    setActive(event, color) {
      this.selectedColor = color;
      this.selectedTrayImage = this.colorToImageMap[color];
      this.selectedTrayName = this.formatTrayName(color);
      this.selectedTrayCode = this.calculateCodeForColor(color);
      const swatches = document.querySelectorAll('.select-color a');
      swatches.forEach(sw => sw.classList.remove('active'));
      event.currentTarget.classList.add('active');
    },
    formatTrayName(color) {
      this.selectedTrayImage = this.colorToImageMap[color];
      this.selectedTrayName = this.formatTrayName(color);
    },
    processColor() {
      const hexColor = this.logoColor.hex;
      const rgbColor = hexToRgb(hexColor);
      console.log("RGB Color: ", rgbColor);
      console.log("Original Image: ", this.originalImage);
      if (this.originalImage && rgbColor) {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] > 0) {
              data[i] = rgbColor.r;
              data[i + 1] = rgbColor.g;
              data[i + 2] = rgbColor.b;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          this.uploadedImage = canvas.toDataURL('image/png');
        };
        img.src = this.originalImage;
      }
      console.log("Processed Image: ", this.uploadedImage);
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onload = (e) => {
          this.uploadedImage = e.target.result; // Set uploaded image
          this.logoColor = '#ffffff';
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              // Assuming white color is [255, 255, 255]
              if (data[i] === 255 && data[i + 1] === 255 && data[i + 2] === 255) {
                data[i + 3] = 0; // Set alpha to 0 (transparent)
              }
            }
            ctx.putImageData(imageData, 0, 0);
            this.originalImage = canvas.toDataURL('image/png');
            this.processColor();
          };
          img.src = e.target.result;
        };
      }
    },
calculateCodeForColor(color) {
    let colorCodeMatch = color.match(/\d{3}$/);
    let colorCode = colorCodeMatch ? colorCodeMatch[0] : '';
    let prefix = color.substring(0, 2); // Get the 'CW' or 'CP' prefix
    return `${this.selectedSizeCode}${prefix}${colorCode}`;
  },
  setCurrentImage(imageNumber) {
    this.currentImage = imageNumber;
  },
  formatTrayName(color) {
      let nameWithoutPrefix = color.slice(2);
      let formattedName = nameWithoutPrefix
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLowerCase()
        .replace(/\d+/g, '')
        .replace(/^\w|\s\w/g, letter => letter.toUpperCase());
      return formattedName;
    },
	selectSize(event) {
		this.selectedSizeCode = event.target.value;
		let selectedOption = event.target.options[event.target.selectedIndex];
		this.selectedTraySize = selectedOption.text;
	},
	downloadImage() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
        filter: function (node) {
            return node.nodeType === Node.ELEMENT_NODE && node.classList && !node.classList.contains('image-navigation');
          }
      })
			.then((dataUrl) => {
				const link = document.createElement('a');
				link.href = dataUrl;
				link.download = 'My-Custom-Cambro-Tray.png';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error) => {
				console.error('Failed to download image', error);
			});
		},
	emailImage() {
      const trayElement = document.getElementById('tray-container');
      html2canvas(trayElement).then((canvas) => {
        canvas.toBlob((blob) => {
          // Convert blob to a data URL
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;

            // Set the subject and body of the email
            const subject = encodeURIComponent('Check out my custom Cambro tray');
            const body = encodeURIComponent(
              `Check out the custom tray I designed: ${base64data}\n\n` +
              `You can design your own here: https://appscambro.com/tray-personalization`
            );
            // Open the default mail client (you cannot attach the image file due to security reasons, but you can include it as a data URL)
            window.open(`mailto:?subject=${subject}&body=${body}`);
          };
        });
      });
	  },
  },
  watch: {
    logoColor(newColor) {
      this.processColor();
    },
  },

  computed: {
    imageStyle() {
      return {
        filter: this.convertHexToCSSFilter(this.color),
      };
    },
	selectedTrayName() {
    const colorName = this.formatTrayName(this.selectedColor);
    const colorCodeMatch = this.selectedColor.match(/(\d+)$/);
    const colorCode = colorCodeMatch ? colorCodeMatch[1] : '';
    return `${colorName} (${colorCode})`;
  },
	productCode() {
    let prefix = this.selectedColor.substring(0, 2);
    let colorCodeMatch = this.selectedColor.match(/\d+$/);
    let colorCode = colorCodeMatch ? colorCodeMatch[0] : '';
    return `${this.selectedSizeCode}${prefix}${colorCode}`;
    }
  },
};
</script>